<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class='col-2 px-3 py-3 d-none d-md-flex'></div>
        
 
        <div class='col px-md-3 py-md-3 pt-3 pt-md-0 px-2 px-md-0 mb-md-5'>
          <Invoice :menuItem.sync="menuItem" />
        </div>

        <CardExtract v-if="menuItem == 'bounties'" />
  
        <div class='col-2 px-3 py-3 d-none d-md-flex'></div>
      </section>
    </main>
  </div>
</template>

<script>
import Invoice from "../../../components/company/invoice";
import CardExtract from "../../../components/company/invoice/cardExtract"; 
  
export default {
  components: {
    Invoice,
    CardExtract,
  },
  data() {
    return { 
      menuItem: 'bounties',
    };
  }, 
};
</script>  